<template>
  <router-view></router-view>
  <auto-logout />
</template>
<script>
  import AutoLogout from "@/views/auth/auto-logout/cover.vue";

  export default {
    name: 'App',
    components: {
      AutoLogout
    }
  };
</script>
<style>
  body {
    font-family: "Poppins", sans-serif !important;
  }

  /* 修复 Message 组件长文本超出显示区域的问题 */
  .ant-message-custom-content {
    max-width: 800px;
    word-break: break-all;
    word-wrap: break-word;
    white-space: pre-wrap;
  }

  .ant-message {
    max-width: 800px;
    left: 50%;
    transform: translateX(-50%);
  }

  .ant-message-notice-content {
    max-width: 800px;
    word-break: break-all;
    word-wrap: break-word;
    white-space: pre-wrap;
  }
</style>
